/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import * as Yup from "yup";
const nameValidation = (
  max: number = Infinity,
  matches: RegExp = /.*/,
  required: boolean = false,
  message: string = "name"
) =>
  Yup.string()
    .max(max, `Maximum ${max} characters allowed in ${message}`)
    .matches(matches, `Only valid characters are allowed in ${message}`)
    .required(required ? `${message} is required` : undefined);
    const minMaxValidation = (min: number, max: number, message?: string) =>
      Yup.string()
        .min(min, `Minimum ${min} characters allowed`)
        .max(max, `Maximum ${max} characters allowed`)
        .required(`Enter Your ${message}`);
        const passwordValidation = Yup.object().shape({
          currentpassword: Yup.string().required("Current password is required"),
          newpassword: Yup.string()
            .required("New password is required")
            .notOneOf(
              [Yup.ref("currentpassword"), null],
              "New password must be different from current password"
            )
            .matches(
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/,
              "New password must contain at least one uppercase letter, one lowercase letter, one number, one special character, and be at least 6 characters long"
            ),
          confirmpassword: Yup.string()
            .required("Confirm password is required")
            .oneOf(
              [Yup.ref("newpassword")],
              "Confirm password must match the new password"
            ),
        });
 export const certificateSchema = Yup.object().shape({
  name: nameValidation(undefined, undefined, true, "Certificate Name"),
});
 export const chefBioSchema = Yup.object().shape({
  chefProfile: minMaxValidation(10, 500, "Bio Description"),
});
 export const brandSchema = Yup.object().shape({
  brandName: minMaxValidation(10, 500, "Brand"),
});
 export const passwordSchema = passwordValidation;
 export const chefProfileSchema = Yup.object().shape({ 
  name:  Yup.string()
      .max(50, "Maximum 50 characters")
      .matches(
        /^[a-zA-Z0-9\s]*$/,
        "Only letters, numbers, and spaces are allowed"
      ),
   email: Yup.string().email("Invalid Email").required("Enter your Email"),
    mobileNumber: Yup.string()
      .matches(/^[0-9]{10}$/, "Enter Your 10 Digit Mobile Number")
      .required("Enter Your MobileNumber"),
    address: Yup.string().required("Enter Your Address"),
});